<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { ref, defineExpose, defineProps, nextTick } from 'vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    maxWidth: {
        type: String,
        default: '400'
    },
    persistent: {
        type: Boolean,
        default: false
    },
    fullscreen: {
        type: Boolean,
        default: false
    },
    transition: {
        type: String,
        default: undefined
    }
});

/*==================================================================*/
/*================== ESTADO DO MODAL ===============================*/
/*==================================================================*/

const aberto = ref(false);

/*==================================================================*/
/*================== ABRIR MODAL ===================================*/
/*==================================================================*/

const abrirModal = async () => {

    aberto.value = true;
    await nextTick();

};

/*==================================================================*/
/*================== FECHAR MODAL ==================================*/
/*==================================================================*/

const fecharModal = async () => {

    aberto.value = false;
    await nextTick();

};

/*==================================================================*/
/*================== EXPOSE ========================================*/
/*==================================================================*/

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <v-dialog
        v-model="aberto"
        :persistent="props.persistent"
        :fullscreen="props.fullscreen"
        :max-width="props.maxWidth"
        :transition="props.transition"
    >

        <slot></slot>

    </v-dialog>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog {
    background-color: white !important;
}

</style>
